
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import CollapseItem from '@/components/collapse.vue';
	import PageFooter from '@/components/page-footer.vue';
	import AddressSelect from '@/components/address-select.vue';
	import {
		mallInfo, mallInfoSave
	} from '@/api/user'
	import UploadImg from '@/components/upload-img.vue';

	import E from 'wangeditor';

	import {
		imgHost
	} from '@/utils/config';

	@Component({
		name: 'supplier-detail',
		components: {
			CollapseItem,
			PageFooter,
			UploadImg,
			AddressSelect
		}
	})
	export default class SupplierDetail extends Vue {
		private imgUrl = imgHost;
		private editor:any = {};
		private formData:any = {
			LogoUrl: '',//商城LOGO,
			MallName: '',//商城名称,
			Title: '',//协议标题,
			Agreement: '',//隐私协议
			StartGroupTime:'',
			MallShareUrl:[],//首页分享图
			HomePageSharePoster:[],
			AllowSupportDaysAfterConfirm:'',
			AllowSupportDaysAfterSend:'',
			ChangeProductReason:[],
			IsOpenChangeProduct:false,
			RefundProductReason:[],
			IsOpenRefundProduct:false,
			AfterSendOnlyRefundMoneyReason:[],
			BeforeSendOnlyRefundMoneyReason:[],
			DamageReshipmentReason:[],
			SinglePayLimit:999999.99,
			PayConfigList:[],
			AlipayAccount:'',
			AlipayPrivateKey:'',
			AlipayRSAFileUrl:[],
			AlipayCertFileUrl:[],
			AlipayFileUrl:[],
			IsOpenDeliverGoodsSMS:true,
			CheckOrderNotice:'',
			OpenRoleGrade:[],
			CustomerOrderSupportInitiator:0,
			OpenKfType:[],
			LogisticsAnnouncement:'',
			AutomaticReceiptDaysAfterSign:'',
			// AutomaticReceiptDaysAfterSend:'',
			WithdrawalMinMoney:'',
			BankCardWithdrawalFeeMoney:'',
			OrderPayWay:1,
			OrderAutomaticCloseMinute:'',
			WithdrawalDescription:'',
			AllowWithdrawalType:[],
			IsLimitWithdrawalDate:false,
			WithdrawalMinDate:'',
			WithdrawalMaxDate:'',
			WithdrawalMoneyLimitList:[],
			IndividualIncomeTaxRate:0,
			IsOpenPurchaseMoneyPayOrder:false,
			PointRule:'',
			IosVersion:'',
			AndroidVersion:'',
			AndroidLink:'',
			IsForceUpdate:false,
			AppUpdateVersionContent:'',
		}
		private formRule:any = {
			'LogoUrl': '请上传商城logo图',
			'MallName': '请设置商城名称',
			'Title': '请输入协议标题',
			'StartGroupTime':'请设置开团时间',
			'Agreement': '请输入协议内容',
			'PointRule':'请完善积分规则',

			'HomePageSharePoster':'请上传首页分享海报图',
			'SinglePayLimit':'请输入单笔收款上限',
		}
		private pickeroptions:any = {
			selectableRange: '00:00:00 - 23:59:59',
			format:'HH:mm',
		}
		private paylist:any = [
			{value:1,label:'汇付'},
			{value:2,label:'微信支付'},
			{value:4,label:'联厚支付'},
			{value:5,label:'真商助手支付'},
		]
		private mounted() {
			this.initEditor();
			this.getData();
		}

		private delPayConfig(i){
			this.formData.PayConfigList.splice(i,1)
		}
		private pushchannel(){
			// if(this.formData.PayConfigList.length>=2){
			// 	return
			// }
			this.formData.PayConfigList.push({
				Id:0,
				IsUse:false,
				PayConfigType:1,
				PayMchId:'',
				WxPayApiKey:'',
				WxRefundCertImgUrl:[],
				AdaPayAppId:'',
				AdaPayAPIKEY:'',
				AdaPayPrivateKey:'',
				DayPayLimit:9999999.99,
				IsOpenWxPay:false,
				IsOpenAlipay:false,
				canedit:true,
				AdapayMemberId:'',
				AdapaySettleAccountId:'',
				SmfMercCode:'',
				SmfPlatformMercCode:'',
				SmfSignKey:'',
				SmfMessageKey:'',
				ZszsMerchantNumber:'',
				ZszsTargetMer:'',
				ZszsAgentId:'',
				ZszsCode:'',
			})
			// console.log(this.formData.PayConfigList)
		}

		private delChangeProductReason(e,key){
			this.formData[key].splice(e,1)
		}

		private pushChangeProductReason(key){
			this.formData[key].push({
				value:''
			})
		}

		
		// 获取省市信息
		private getAddress(list: string[]) {
			this.formData.CompanyReceiveProvince = list[0];
			this.formData.CompanyReceiveCity = list[1];
			this.formData.CompanyReceiveArea = list[2];
		}

		//初始化富文本框
		private initEditor(){
			this.editor = new E('#editContent');
			this.editor.config.zIndex = 1;
			this.editor.config.onchange = (newHtml: any) => {
				this.formData.Agreement = newHtml
			}
			this.editor.create();
		}

		// 返回上一页
		private toBack() {
			this.$router.go(-1)
		}

		// 上传成功
		private uploadSuc(list: any, type ? : string,i?:number) {
			if(type=='WxRefundCertImgUrl'){
				this.formData.PayConfigList.map((v,y)=>{
					if(v.PayConfigType==2&&y==i){
						v[type] = list
						// console.log(type,v[type])
					}
					return v
				})
				return 
			}
			// this.formData[type] = list[0]
			if(type=='MallShareUrl'||type=="HomePageSharePoster"){
				this.formData[type] = list
				// console.log(this.formData[type],123)
				return 
			}
			if(type=='LogoUrl'){
				this.formData[type] = list[0]
				return
			}
			this.formData[type] = list
		}

		// 数据是否为空
		private isEmpty() {
			for (let key in this.formData) {
				if (this.formRule[key] && !this.formData[key]) {
					this.$message({
						type: 'warning',
						message: this.formRule[key]
					})
					return true
				}
			}
			if(this.formData.CompanyRecipientPhone && this.formData.CompanyRecipientPhone.length!=11){
				this.$message.warning('请输入正确的手机号')
				return true
			}
			if(!this.formData.HomePageSharePoster||!this.formData.HomePageSharePoster.length){
				this.$message.warning('请上传首页分享海报图')
				return true
			}
			if(!this.formData.IosVersion||!this.formData.AndroidVersion){
				this.$message.warning('请设置app版本号')
				return true
			}
			if(!this.formData.AndroidLink){
				this.$message.warning('请输入安卓下载链接')
				return true
			}
			let two = /^\d+(\.\d{1,2})?$/
			let testnum = /^[0-9]+$/
			if(this.formData.SinglePayLimit<0.01||this.formData.SinglePayLimit>999999.99||!two.test(this.formData.SinglePayLimit)){
				this.$message.warning('请输入正确的金额')
				return true
			}
			if(!this.formData.PayConfigList||!this.formData.PayConfigList.length){
				return false
			}
			for(let item of this.formData.PayConfigList){
				// console.log(item)
				if(!item.PayMchId){
					this.$message.warning('请输入商户号')
					return true
				}else if(item.PayConfigType==1){
					if(!item.AdaPayAppId||!item.AdaPayAPIKEY||!item.AdaPayPrivateKey){
						this.$message.warning('请补充商户支付信息')
						return true
					}else if(!item.DayPayLimit){
						this.$message.warning('请输入商户单日收款上限')
						return true
					}else if(item.DayPayLimit<0.01||item.DayPayLimit>9999999.99||!two.test(item.DayPayLimit)){
						this.$message.warning('请输入正确的金额')
						return true
					}
				}else if(item.PayConfigType==2){
					if(!item.WxPayApiKey){
						this.$message.warning('请补充商户支付信息')
						return true
					}else if(!item.WxRefundCertImgUrl||!item.WxRefundCertImgUrl.length){
						this.$message.warning('请上传退款证书')
						return true
					}
				}else if(item.PayConfigType==4){
					if(!item.SmfMercCode){
						this.$message.warning('请输入商户号')
						return true
					}else if(!item.SmfPlatformMercCode){
						this.$message.warning('请输入平台商户号')
						return true
					}else if(!item.SmfSignKey){
						this.$message.warning('请输入签名秘钥')
						return true
					}else if(!item.SmfMessageKey){
						this.$message.warning('请输入报文秘钥')
						return true
					}
				}
			}
			return false;
		}

		private check(){
			let num1=this.formData.AllowSupportDaysAfterConfirm
			let num2=this.formData.AllowSupportDaysAfterSend
			let testnum = /^[0-9]+$/
			let two = /^\d+(\.\d{1,2})?$/
			if(num1<1||num1>999||!testnum.test(num1.toString())){
				this.$message.error('售后发起时间请输入1~999的整数')
				return false
			}else if(num2<1||num2>999||!testnum.test(num2.toString())){
				this.$message.error('售后发起时间请输入1~999的整数')
				return false
			}
			let num3=this.formData.AutomaticReceiptDaysAfterSign
			// let num4=this.formData.AutomaticReceiptDaysAfterSend
			if(num3<1||num3>999||!testnum.test(num3.toString())){
				this.$message.error('订单自动确认收货时间请输入1~999的整数')
				return false
			}
			// else if(num4<1||num4>999||!testnum.test(num4.toString())){
			// 	this.$message.error('订单自动确认收货时间请输入1~999的整数')
			// 	return false
			// }else if(Number(num3) < Number(num4)){
			// 	this.$message.error('自动确认收货配置异常，请确认后保存')
			// 	return false
			// }
			if(!this.formData.AllowWithdrawalType||!this.formData.AllowWithdrawalType .length){
				this.$message.error('请选择提现账户类型')
				return false
			}
			if(this.formData.IsLimitWithdrawalDate){
				let numOfMinDate = this.formData.WithdrawalMinDate
				let numOfMaxDate = this.formData.WithdrawalMaxDate
				if(!numOfMinDate||numOfMinDate<1||numOfMinDate>31||numOfMinDate!=parseInt(numOfMinDate)){
					this.$message.error('请输入正确申请提现时间')
					return false
				}
				if(!numOfMaxDate||numOfMaxDate<1||numOfMaxDate>31||numOfMaxDate!=parseInt(numOfMaxDate)){
					this.$message.error('请输入正确申请提现时间')
					return false
				}
				if(numOfMinDate>numOfMaxDate){
					this.$message.error('请输入正确的申请提现时间')
					return false
				}
			}
			for(let obj of this.formData.WithdrawalMoneyLimitList){
				// console.log(obj,22)
				obj.WithdrawalMinMoney = Number(obj.WithdrawalMinMoney)
				if(this.formData.AllowWithdrawalType.includes(obj.WithdrawalType)){
					if(obj.WithdrawalMinMoney<1||!obj.WithdrawalMinMoney||!two.test(obj.WithdrawalMinMoney.toString())){
						obj.WithdrawalMinMoney = ''
						this.$message.error('最低提现金额请输入1~99999的数字，最多两位小数')
						return false
					}else if(obj.WithdrawalMinMoney>99999||!two.test(obj.WithdrawalMinMoney.toString())){
						this.$message.error('最大提现金额限制为99999')
						return false
					}
				}
			}
			
			let num6=this.formData.BankCardWithdrawalFeeMoney
			if(num6<0||!two.test(num6.toString())){
				this.$message.error('服务费请输入0~1000的数字，最多两位小数')
				return false
			}else if(num6>1000||!two.test(num6.toString())){
				this.$message.error('单笔服务费最高1000元')
				return false
			}

			let num7 = this.formData.IndividualIncomeTaxRate
			if(num7<0||!two.test(num7.toString())){
				this.$message.error('个税收取请输入0~100的数字，最多两位小数')
				return false
			}else if(num7>100||!two.test(num7.toString())){
				this.$message.error('个税收取最高为100')
				return false
			}


			if(this.formData.OrderPayWay==2){
				let num7 = this.formData.OrderAutomaticCloseMinute
				if(num7<1||num7>9999||!testnum.test(num7.toString())){
					this.$message.error('订单自动关闭请输入1~9999的整数')
					return false
				}
			}
			return true
		}

		// 获取供应商信息
		private async getData() {
			try {
				const res: any = await mallInfo({})
				let formData = res.Result;
				formData.MallShareUrl = formData.MallShareUrl?[formData.MallShareUrl]:[]
				if(formData.ChangeProductReason&&formData.ChangeProductReason.length){
					formData.ChangeProductReason = formData.ChangeProductReason.map(v=>{
						return {value:v}
					})
				}else{
					formData.ChangeProductReason = []
				}
				if(formData.RefundProductReason&&formData.RefundProductReason.length){
					formData.RefundProductReason = formData.RefundProductReason.map(v=>{
						return {value:v}
					})
				}else{
					formData.RefundProductReason = []
				}
				if(formData.BeforeSendOnlyRefundMoneyReason&&formData.BeforeSendOnlyRefundMoneyReason.length){
					formData.BeforeSendOnlyRefundMoneyReason = formData.BeforeSendOnlyRefundMoneyReason.map(v=>{
						return {value:v}
					})
				}else{
					formData.BeforeSendOnlyRefundMoneyReason = []
				}
				if(formData.AfterSendOnlyRefundMoneyReason&&formData.AfterSendOnlyRefundMoneyReason.length){
					formData.AfterSendOnlyRefundMoneyReason = formData.AfterSendOnlyRefundMoneyReason.map(v=>{
						return {value:v}
					})
				}else{
					formData.AfterSendOnlyRefundMoneyReason = []
				}
				if(formData.DamageReshipmentReason&&formData.DamageReshipmentReason.length){
					formData.DamageReshipmentReason = formData.DamageReshipmentReason.map(v=>{
						return {value:v}
					})
				}else{
					formData.DamageReshipmentReason = []
				}
				formData.PayConfigList = formData.PayConfigList.map(v=>{
					v.WxRefundCertImgUrl = v.WxRefundCertImgUrl?[v.WxRefundCertImgUrl]:[]
					v.canedit = false
					return v
				})
				formData.AlipayRSAFileUrl = formData.AlipayRSAFileUrl?[formData.AlipayRSAFileUrl]:[]
				formData.AlipayCertFileUrl = formData.AlipayCertFileUrl?[formData.AlipayCertFileUrl]:[]
				formData.AlipayFileUrl = formData.AlipayFileUrl?[formData.AlipayFileUrl]:[]

				//按照支付宝 微信 银行卡的顺序换个位置
				formData.WithdrawalMoneyLimitList = [
					formData.WithdrawalMoneyLimitList.find(v=>v.WithdrawalType==1),
					formData.WithdrawalMoneyLimitList.find(v=>v.WithdrawalType==2),
					formData.WithdrawalMoneyLimitList.find(v=>v.WithdrawalType==0),
				]
				formData.IndividualIncomeTaxRate = (((formData.IndividualIncomeTaxRate*10000) as any).toFixed(0))/100
				this.formData = formData
				// console.log(this.formData)
				this.editor.txt.html(res.Result.Agreement);
				this.$nextTick(()=>{
					this.$forceUpdate()
				})
			} catch (err) {
				console.error('supplierInfo ===>', err)
			}
		}

		// 提交信息
		private submit() {
			if (this.isEmpty() || !this.check()) return false;
			this.doCreate()
		}

		// 创建
		private async doCreate() {
			try {
				let data = JSON.parse(JSON.stringify(this.formData))
				// data.LogoUrl = data.LogoUrl[0]?data.LogoUrl[0]:''
				data.MallShareUrl = data.MallShareUrl[0]?data.MallShareUrl[0]:''
				// return 
				data.ChangeProductReason = data.ChangeProductReason.map(v=>v.value)
				data.RefundProductReason = data.RefundProductReason.map(v=>v.value)
				data.AfterSendOnlyRefundMoneyReason = data.AfterSendOnlyRefundMoneyReason.map(v=>v.value)
				data.BeforeSendOnlyRefundMoneyReason = data.BeforeSendOnlyRefundMoneyReason.map(v=>v.value)
				data.DamageReshipmentReason = data.DamageReshipmentReason.map(v=>v.value)
				
				//商户类型 为微信支付时 支付宝支付不可勾选
				if(data.PayConfigList&&data.PayConfigList.length){
					data.PayConfigList = data.PayConfigList.map(v=>{
						v.WxRefundCertImgUrl = v.WxRefundCertImgUrl [0]||[]
						if(v.PayConfigType==2){
							v.IsOpenAlipay = false
							v.AdapayMemberId = ''
							v.AdapaySettleAccountId = ''
						}
						return v
					})
				}
				data.IndividualIncomeTaxRate = ((data.IndividualIncomeTaxRate*100) as any).toFixed(0)/10000
				// console.log(data.IndividualIncomeTaxRate)
				const res: any = await mallInfoSave(data)
				this.$message({
					type: 'success',
					message: '保存成功'
				})
				this.getData()
			} catch (err) {
				console.error('supplierInfo ===>', err)
			}
			// try {
			// 	await creareSupplier(this.formData);
			// 	this.$message({
			// 		type: 'success',
			// 		message: '创建成功'
			// 	})
			// 	this.toBack()
			// } catch (err) {
			// 	this.$message({
			// 		type: 'error',
			// 		message: '创建失败'
			// 	})
			// 	console.log('creareSupplier ===>', err);
			// }
		}

	}
